import React from 'react';
import {Flex, SVGButton} from '/app/src/component'

const ListItemStyle = {
    height: '100%',
    grow: 1,
    vAlignContent: 'center',
    paddingLeft: '20px',
    position: 'relative',
    //cursor: 'pointer',
    //backgroundHover: 'mediumgrey',
    backgroundColor: 'darkwhite',
    //hover: 'black',
    userSelect: 'none',
}

const VisibleIconStyle = {
    src:'/images/Visible_Locked_M.svg',
    marginLeft: '20px'
}

export default ({label,parentVisible, ...rest})=>{
        return(
            <Flex
                {...rest}
                grow={1}
                vAligncontent='center'
                hAlignContent='right'
                marginBottom='5px'
                shrink={0}
                >
                <Flex {...ListItemStyle}
                    borderRadius='200px'>
                    <Flex marginRight='auto' color={parentVisible?'black':'lightgrey'}>
                        <div className='ellipsis'>
                            {label}
                        </div>
                    </Flex>
                    <Flex width='120px' shrink={0} grow={0}>
                    </Flex>
                </Flex>
                <SVGButton {...VisibleIconStyle} disabled={true}/>
            </Flex>
        )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/_LockItem.js